import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old Tenancy invoices list, kept only as a redirect.
 *
 * The list is the Tenancy invoices tab on Bills now — one list with the shared table, its column
 * picker and saved workspaces, rather than a hand-built second copy. This address was the only
 * way in for long enough to be bookmarked and pasted into emails, so it forwards there instead of
 * falling through to a not-found page. `replace` so Back does not bounce off it.
 */
export const Route = createFileRoute('/financial/invoices/')({
  beforeLoad: () => {
    throw redirect({ to: '/bills', search: { tab: 'tenancy' }, replace: true });
  },
});
